import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import {
  Card, Col, Row,
} from 'reactstrap';
import './SignAgreement.scss';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import { SecuritizePage } from '@securitize/ui-components';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getName } from 'i18n-iso-countries';
import classnames from 'classnames';
import queryString from 'query-string';
import moment from 'moment';
import Footer from '../Footer';
import { getOpportunity } from '../OpportunitiesDetailsPage/actions';
import { getAgreement, getAgreementByPull } from './actions';
import OpportunityCalculator from '../OpportunityCalculator';
import ExitProcess from '../ExitProcess';
import CustomCircleProgressBar from '../CustomCircleProgressBar';
import { MixPanel } from '../../../../../utils/helpers/mixPanel';
import { setDocusignRedirectData } from '../../../../../utils/helpers/docusignRedirecUtils';

const entityTypes = [
  { value: 'revocable-trust', label: 'Revocable Trust' },
  { value: 'irrevocable-trust', label: 'Irrevocable Trust' },
  { value: 'limited-general-partnership', label: 'Limited Partnership/General Partnership' },
  { value: 'limited-partnership/general-partnership', label: 'Limited Partnership/General Partnership' },
  { value: 'llc', label: 'LLC' },
  { value: 'corporation', label: 'Corporation' },
  { value: 'fund', label: 'Fund' },
  { value: 'other', label: 'Other' },
];

const SignAgreement = (props) => {
  const {
    issuerVariables, nextPage, previousPage, opportunityId, signedAgreement, getAgreement, getOpportunity,
    opportunity, user, opportunityError, opportunityLoading, currentPage, getAgreementByPull, pageNumber, agreementLoading,
    opportunityUpdateInProgress, routesLength,
  } = props;

  const {
    investorEmail, investorFullName, entityName, investorType, city, address1, zipCode, state, countryCode, phoneNumber,
    entityType, birthDate, investorId,
  } = user;
  const history = useHistory();
  const { search } = useLocation();
  const params = useParams();
  const {
    config: { issuerId },
  } = useSelector((reduxState) => reduxState.issuerConfiguration);

  const [pullActive, setPullActive] = useState(false);
  const { redirected } = queryString.parse(search) || {};

  const pullAgreement = () => {
    if (!pullActive) {
      setTimeout(() => {
        getAgreementByPull(opportunityId, {
          onFinish: (err, data) => {
            setPullActive(false);
            if (!(data && data.agreement)) {
              pullAgreement();
            }
          },
        });
      }, 5000);
      setPullActive(true);
    }
  };

  useEffect(() => {
    if (!opportunityLoading && (!Object.keys(opportunity).length || parseInt(params.id) !== opportunity.id)) {
      getOpportunity(opportunityId);
    }
    if (redirected === 'true') pullAgreement();
    else if (!agreementLoading) getAgreement(opportunityId);
  }, [opportunityLoading, opportunity, params]);

  const { currency, amount, investmentId } = opportunity.investorInvestmentDetails || {};
  const username = (investorType === 'entity' ? entityName : investorFullName) || investorEmail;
  const country = getName(countryCode, 'EN') || '';
  const address = `${city}, ${address1}, ${zipCode},${state || ''} ${country}`;
  const addressOne = `${address1}`;
  const addressTwo = `${city}, ${state || ''} ${zipCode || city}`;

  const translatedEntityType = investorType === 'individual'
    ? 'Individual' : (entityTypes.find((type) => type.value === entityType) || {}).label;

  const docusignInvestorTypes = {
    individual: 'Individual',
    entity: 'Entity',
  };

  const docusignUrl = () => `${issuerVariables['docusign-iframe-base-url']}?`
    + `PowerFormId=${opportunity.subscriptionAgreementDocusignId}&`
    + `Self_UserName=${encodeURIComponent(issuerVariables['docusign-approver-name'])}&`
    + `Self_Email=${encodeURIComponent(issuerVariables['docusign-approver-email'])}&`
    + `Investor_UserName=${encodeURIComponent(username)}&`
    + `Investor_Email=${encodeURIComponent(investorEmail)}&`
    + `Investor_investortype=${encodeURIComponent(docusignInvestorTypes[investorType])}&`
    + `Investor_entitytype=${encodeURIComponent(translatedEntityType || 'Other')}&`
    + `phonenumber=${encodeURIComponent(phoneNumber || '')}&`
    + `birthdate=${encodeURIComponent(
      moment(birthDate).isValid() ? moment(birthDate).format('YYYY/MMM/DD') : '',
    )}&`
    + `address=${encodeURIComponent(address)}&`
    + `addressone=${encodeURIComponent(addressOne)}&`
    + `addresstwo=${encodeURIComponent(addressTwo)}&`
    + `currency=${encodeURIComponent(currency)}&`
    + `country=${encodeURIComponent(country)}&`
    + `entityname=${encodeURIComponent(username)}&`
    + `investmentid=${encodeURIComponent(btoa((investmentId || '').replace('-', ' ')))}&`
    + `amount=${encodeURIComponent(amount)}`;

  return (
    <span className="sign-agreement animated fadeIn">
      <div className="mb-5">
        <ExitProcess />
      </div>
      <SecuritizePage
        isLoading={opportunityLoading || agreementLoading}
        isError={opportunityError}
      >
        <Row className="p-0 mb-4 mt-5">
          <Col className="d-flex align-items-center p-0">
            <CustomCircleProgressBar currentValue={pageNumber} totalItems={routesLength} />
            <h1 className="font-32 mb-0">
              {`0${pageNumber}. `}
              <Translate translationKey="Texts.sign-agreement" />
            </h1>
          </Col>
        </Row>
        <Row className={classnames('sign-agreement__docusign p-0 mb-5 flex-wrap-reverse ', {
          'align-items-end': !opportunity.isTokenCalculatorVisible,
        })}
        >
          <Col xs={12} md={8} className="sign-agreement__docusign__row">
            <Card className="sign-agreement__docusign__card  border-0 box-shadow border-0">
              <div className="d-flex justify-content-between align-items-center pb-3">
                <h4 className="font-20 ">
                  <i className="icon-details mr-2" />
                  {
                    signedAgreement.agreement
                      ? <Translate translationKey="Texts.successfully-signed" />
                      : <Translate translationKey="Texts.sign-to-proceed" />
                  }
                </h4>
              </div>
              {
                signedAgreement.agreement
                  ? (
                    <div className="pt-2 pb-">
                      <Card className="animated fadeIn sign-agreement__docusign__preview border-0 box-shadow ">
                        {/* eslint-disable-next-line */}
                        <div
                          id="btn-signed-agreement-preview"
                          className="sign-agreement__docusign__preview__top"
                          onClick={() => window.open(signedAgreement.agreement, '_blank')}
                        >
                          {/* eslint-disable-next-line react/no-unknown-property */}
                          <embed scrolling="no" src={signedAgreement.agreement} />
                        </div>
                      </Card>
                      <div className="issuer-primary font-16">
                        <i className="icon-check mr-2" />
                        <span><Translate translationKey="Texts.agreement-signed" /></span>
                      </div>
                    </div>
                  )
                  : (
                    <>
                      <span className="font-16 sign-agreement__docusign__card__text pt-3 pb-3">
                        <Translate translationKey="Texts.click-to-open-subscription-agreement" />
                      </span>
                      <Row className="align-items-center pt-3">
                        <Col xs={7}>
                          <LaddaButton
                            id="btn-sign-subscription-agreement"
                            className="mr-4 font-16 btn p-3 issuer-button-primary w-100 font-weight-bold text-white font-16"
                            data-style={ZOOM_OUT}
                            loading={opportunityUpdateInProgress || pullActive}
                            onClick={() => {
                              MixPanel.track('sign-agreement-click', { opportunityId });
                              setDocusignRedirectData(issuerId, opportunityId, investorId, currentPage);
                              pullAgreement();
                              window.location.href = docusignUrl();
                            }}
                          >
                            <Translate translationKey="Texts.sign-agreement" />
                          </LaddaButton>
                        </Col>
                        <Col xs={5} className="p-0">
                          <div>
                            <span className="text-nowrap powered-by font-14">
                              Powered by
                              &nbsp;
                            </span>
                            <span className="font-16 font-weight-semi text-nowrap font-weight-bold">DocuSign</span>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )
              }
            </Card>
          </Col>
          <OpportunityCalculator
            opportunityId={opportunityId}
            onOpportunityUpdate={() => {
              const parsedSearch = queryString.parse(search);
              if (parsedSearch.redirected) parsedSearch.redirected = 'false';
              history.replace({ search: queryString.stringify(parsedSearch) });
              if (signedAgreement.agreement) {
                getAgreement(opportunityId);
              }
            }}
          />
        </Row>
        <Row className="sign-agreement__footer">
          <Col className="pl-0">
            <Footer
              continueDisabled={!signedAgreement.agreement}
              onBack={
                () => history.push(previousPage.includes('investor-qualification')
                  ? `/opportunity/${opportunityId}`
                  : previousPage)
              }
              onContinue={() => {
                history.push(nextPage);
              }}
            />
          </Col>
        </Row>
      </SecuritizePage>
    </span>
  );
};

SignAgreement.defaultProps = {
  user: {},
  opportunity: {},
  signedAgreement: {},
  issuerVariables: {},
  nextPage: '',
  currentPage: '',
  previousPage: '',
  opportunityId: '',
  opportunityLoading: false,
  agreementLoading: false,
  opportunityError: false,
  opportunityUpdateInProgress: false,
  pageNumber: 0,
  getOpportunity: () => undefined,
  getAgreement: () => undefined,
  getAgreementByPull: () => undefined,
};

SignAgreement.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  opportunity: PropTypes.objectOf(PropTypes.any),
  signedAgreement: PropTypes.objectOf(PropTypes.any),
  opportunityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  opportunityError: PropTypes.bool,
  opportunityLoading: PropTypes.bool,
  agreementLoading: PropTypes.bool,
  opportunityUpdateInProgress: PropTypes.bool,
  currentPage: PropTypes.string,
  nextPage: PropTypes.string,
  previousPage: PropTypes.string,
  issuerVariables: PropTypes.objectOf(PropTypes.any),
  getOpportunity: PropTypes.func,
  getAgreementByPull: PropTypes.func,
  getAgreement: PropTypes.func,
  pageNumber: PropTypes.number,
  routesLength: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  const {
    investment: { opportunity, agreement }, issuerConfiguration, auth,
  } = state;
  return {
    opportunityError: opportunity.isError,
    opportunityLoading: opportunity.isLoading,
    agreementLoading: agreement.isLoading,
    opportunityUpdateInProgress: opportunity.isUpdateLoading,
    opportunity: opportunity.data,
    issuerVariables: issuerConfiguration.variables,
    signedAgreement: agreement.data,
    user: auth.user,
  };
};

export default connect(
  mapStateToProps,
  { getOpportunity, getAgreement, getAgreementByPull },
)(SignAgreement);
